import React from "react";
import { ToggleLeftIcon } from "lucide-react";
import "../../css/Sidebar.css";
import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div
      className={`sidebar h-screen ${
        isOpen ? "w-56" : "w-0"
      } lg:w-56 text-white transition-all duration-300 fixed lg:relative z-50 overflow-y-auto py-4`}
      style={{ backgroundColor: "#1F1E1E", borderRadius: "24px" }}
    >
      <div className="flex items-center justify-center h-16 px-4 mb-4">
        {/* Logo */}
        <img
          src="/assets/Transparent background.png"
          alt="Ducktail Logo"
          onClick={() => handleNavigation("/")}
          className={`h-12 pr-4 ${isOpen ? "block" : "hidden"} lg:block cursor-pointer`}
        />
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="absolute right-4 text-white lg:hidden font-semibold"
        >
          {isOpen ? <ToggleLeftIcon size={20} /> : ""}
        </button>
      </div>

      {/* Navigation links */}
      <nav className={`mt-4 ${isOpen ? "block" : "hidden"} lg:block space-y-2`}>
        <div className="relative">
          <span className="absolute inset-y-0 left-0 flex items-center pl-3">
            <img
              src="/sidebaricons/project invite 1.png"
              alt="Ducktail Logo"
              className="h-6 w-6"
            />
          </span>
          <button
            onClick={() => handleNavigation("/customer/projectinvite")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/customer/projectinvite") ? "bg-[#616161] rounded-xl" : ""
            }`}
          >
            Project Invite
          </button>
        </div>

        <div className="relative">
          <span className="absolute inset-y-0 left-0 flex items-center pl-4">
            <img
              src="/sidebaricons/Job list3.png"
              alt="Ducktail Logo"
              className="h-5 w-5"
            />
          </span>
          <button
            onClick={() => handleNavigation("/customer/livecard")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/customer/livecard") ? "bg-[#616161] rounded-xl" : ""
            }`}
          >
            Live Project
          </button>
        </div>

        <div className="relative">
          <span className="absolute inset-y-0 left-0 flex items-center pl-4">
            <img
              src="/sidebaricons/live1.png"
              alt="Ducktail Logo"
              className="h-5 w-5"
            />
          </span>
          <button
            onClick={() => handleNavigation("/customer/holdcard")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/customer/holdcard") ? "bg-[#616161] rounded-xl" : ""
            }`}
          >
            Hold Project
          </button>
        </div>

        <div className="relative">
          <span className="absolute inset-y-0 left-0 flex items-center pl-4">
            <img
              src="/sidebaricons/rejected1.png"
              alt="Ducktail Logo"
              className="h-5 w-5"
            />
          </span>
          <button
            onClick={() => handleNavigation("/customer/rejectcard")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/customer/rejectcard") ? "bg-[#616161] rounded-xl" : ""
            }`}
          >
            Rejection Projects
          </button>
        </div>

        <div className="relative">
          <span className="absolute inset-y-0 left-0 flex items-center pl-4">
            <img
              src="/sidebaricons/faq_1761715511.png"
              alt="Ducktail Logo"
              className="h-5 w-5"
            />
          </span>
          <button
            onClick={() => handleNavigation("/customer/requestcard")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/customer/requestcard") ? "bg-[#616161] rounded-xl" : ""
            }`}
          >
            Completion Request
          </button>
        </div>

        <div className="relative">
          <span className="absolute inset-y-0 left-0 flex items-center pl-4">
            <img
              src="/sidebaricons/Profile 2.png"
              alt="Ducktail Logo"
              className="h-5 w-5"
            />
          </span>
          <button
            onClick={() => handleNavigation("/customer/completedcard")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl ${
              isActive("/customer/completedcard") ? "bg-[#616161] rounded-xl" : ""
            }`}
          >
            Completed Projects
          </button>
        </div>

        <div className="relative">
          <span className="absolute inset-y-0 left-0 flex items-center pl-4">
            <img
              src="/sidebaricons/Profile1.png"
              alt="Ducktail Logo"
              className="h-6 w-6"
            />
          </span>
          <button
            onClick={() => handleNavigation("/customer/profile")}
            className={`block pl-14 py-3 w-full text-left text-sm hover:bg-[#616161] font-semibold rounded-xl  ${
              isActive("/customer/profile") ? "bg-[#616161] rounded-xl" : ""
            }`}
          >
            Profile
          </button>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
